import { FC } from 'react';
import { PlayerPortalsPageTemplate } from '../../templates';
import SEOWrapper from '../../SEOWrapper/SEOWrapper';
import { PlayerPortalsGridPageProps } from './types';
import { useScreenDetector } from '../../../hooks';
import { RenderOn } from '@r-and-a-shared-ui/common-ui';
import { PlayerPortalsGridPageBodyContent } from './PlayerPortalsGridPageBodyContent';

const PageContent: FC<PlayerPortalsGridPageProps> = ({
  seo,
  pageColumns,
}: PlayerPortalsGridPageProps) => {
  return (
    <>
      <SEOWrapper
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        noindex={seo?.noindex}
        nofollow={seo?.nofollow}
        urlSlug={seo?.urlSlug}
      />
      <PlayerPortalsGridPageBodyContent pageColumns={pageColumns} />
    </>
  );
};

export const PlayerPortalsGridPage: FC<PlayerPortalsGridPageProps> = ({
  seo,
  mobile,
  pageColumns,
  pageTemplate,
}) => {
  if (pageTemplate) {
    return (
      <PlayerPortalsPageTemplate
        header={pageTemplate.header}
        footer={pageTemplate.footer}
      >
        <PageContent
          seo={seo}
          pageTemplate={pageTemplate}
          mobile={mobile}
          pageColumns={pageColumns}
        />
      </PlayerPortalsPageTemplate>
    );
  }

  return (
    <PageContent
      seo={seo}
      pageTemplate={pageTemplate}
      mobile={mobile}
      pageColumns={pageColumns}
    />
  );
};
